import EnvFile from "./assets/env-dev.json";
import type { DplEnvVariables } from "./types/env";

window.MLBBest = {
  envVariables: EnvFile as DplEnvVariables,
};
